<template>
  <b-container>
    <b-form
      class="mt-5"
      @submit.prevent="onSubmit"
    >
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="メールアドレス"
            label-for="email"
          >
            <b-form-input
              id="email"
              v-model="form.email"
              type="email"
              required
              placeholder="mymail@domain.jp"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="ニックネーム"
            label-for="username"
          >
            <b-form-input
              id="username"
              v-model="form.username"
              type="text"
              required
              placeholder="hanako"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="名"
            label-for="firstname"
          >
            <b-form-input
              id="firstname"
              v-model="form.firstName"
              type="text"
              required
              placeholder="花子"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="性"
            label-for="lastname"
          >
            <b-form-input
              id="lastname"
              v-model="form.lastName"
              type="text"
              placeholder="虹村"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!--<b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="団体名（任意）"
            label-for="company"
          >
            <b-form-input
              id="company"
              v-model="form.company"
              type="text"
              placeholder="虹の会"
            />
          </b-form-group>
        </b-col>
      </b-row>-->
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="パスワード"
            label-for="password"
          >
            <b-form-input
              id="password"
              v-model="form.password"
              type="password"
              required
              placeholder="6文字以上で入力してください"
              minlength="6"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="justify-content-center mb-3">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-checkbox
            id="terms"
            v-model="termsCheck"
            required
          >
            本サービスの<b-link :to="{ name: 'privacy-policy' }">
              プライバシーポリシー
            </b-link>及び<b-link :to="{ name: 'eula' }">
              利用規約
            </b-link>を同意のうえ、アカウント登録を行ってください。
          </b-form-checkbox>
          <b-form-invalid-feedback :force-show="termsError">
            同意します
          </b-form-invalid-feedback>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <b-button
              type="submit"
              block
              variant="primary"
            >
              <b-icon
                v-if="authStatus === 'loading'"
                icon="three-dots"
                animation="cylon"
                font-scale="1"
              />
              <span v-else>登録</span>
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <p class="text-center">
          アカウントをお持ちの方<b-link :to="{ name: 'login' }">
            ログイン
          </b-link>
        </p>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import { USER_REGISTER } from "@/store/constant";
import { mapGetters } from "vuex";

export default {
  name: 'Signup',
  data() {
    return {
      form: {
        username: '',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
      },
      termsCheck: false,
      termsError: false,
    }
  },
  computed: {
    ...mapGetters(['authStatus'])
  },
  methods: {
    onSubmit() {
      if (!this.termsCheck) {
        this.termsError = !this.termsCheck;
        return false;
      }
      this.$store.dispatch(USER_REGISTER, this.form)
        .then(() => {
          this.$router.push('/login');
        })
    },
  }
}
</script>
